import React from "react";

const ServicesSection = () => {
  const items = [
    {
      title: "Product Engineering",
      desc: "We specialize in R&D, embedded systems, microcontrollers, FPGAs, custom sensors, and control systems — from design to prototyping.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
        </svg>
      )
    },
    {
      title: "Manufacturing & Industrialization",
      desc: "From smart energy devices to IoT gateways and custom solutions, we deliver reliable products with CE, FCC, BIS, and ISO certifications.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-8m-8 0H3m2 0h2M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
        </svg>
      )
    },
    {
      title: "Hardware-First Services",
      desc: "System integration, automation, and lifecycle management ensure every product is market-ready.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    },
    {
      title: "Cloud & Applications",
      desc: "Secure device connectivity, data pipelines, and analytics that enhance hardware performance.",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="{1.5}" d="M3 15a4 4 0 004 4h9a5 5 0 10-.1-9.999 5.002 5.002 0 10-9.78 2.096A4.001 4.001 0 003 15z" />
        </svg>
      )
    }
  ];

  return (
    <section id="services" className="py-5" style={{ background: "var(--canvas)" }}>
      <div className="container">
        {/* Header */}
        <div className="text-center mb-5 section-header">
          <span
            className="badge rounded-pill px-3 py-2 mb-2"
            style={{
              background: "var(--chip)",
              color: "var(--chiptext)",
              border: "1px solid var(--cardborder)",
            }}
          >
            What We Provide
          </span>
          <h2 className="display-5 fw-bold mb-3" style={{ color: "var(--secondarytext)" }}>
            Services We Provide
          </h2>
          <div className="divider mx-auto mb-4"></div>
          <p className="mt-3 lead" style={{ color: "var(--secondarytext)", opacity: 0.8 }}>
            Hardware-first expertise with modern manufacturing and cloud support.
          </p>
        </div>

        {/* Cards */}
        <div className="row g-4">
          {items.map((it, idx) => (
            <div key={idx} className="col-12 col-md-6 col-lg-3">
              <div
                className="card h-100 service-card border-0"
                style={{ 
                  background: "var(--card)", 
                  border: "1px solid var(--cardborder)",
                  borderRadius: "16px"
                }}
              >
                <div className="card-body text-center p-4">
                  <div
                    className="d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                    style={{
                      width: 64,
                      height: 64,
                      background: "var(--chip)",
                      color: "var(--primary)",
                    }}
                  >
                    {it.icon}
                  </div>
                  <h5 className="card-title mb-3" style={{ color: "var(--secondarytext)" }}>
                    {it.title}
                  </h5>
                  <p className="card-text" style={{ color: "var(--secondarytext)", opacity: 0.8 }}>
                    {it.desc}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Hover polish */}
        <style>{`
          .service-card {
            transition: all 0.3s ease;
          }
          .service-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 14px 30px -6px rgba(1, 62, 251, 0.15);
            border-color: var(--primary) !important;
          }
          .service-card:hover .card-body > div:first-child {
            background: var(--primary) !important;
            color: white !important;
          }
        `}</style>
      </div>
    </section>
  );
};

export default ServicesSection;